import { Component } from '@angular/core';

@Component({
  selector: 'allas-features-app-movil',
  imports: [],
  template: `
    <section class="grid grid-cols-1 xl:grid-cols-3 gap-6">
      <article class="flex flex-col gap-2">
        <img
          src="/images/services/aplicacion-movil/administra-tu-auto.webp"
          alt="Administra tu Auto"
        />
        <h2 class="text-2xl xl:text-4xl font-medium fs-condensed">
          Administración de tu Garaje
        </h2>
        <p class="text-sm xl:text-2xl fs-condensed">
          Agrega y Remueve vehículos de tu Garaje, <br />
          lleva la historia de mantenimiento y más!
        </p>
      </article>
      <article class="flex flex-col gap-2">
        <img
          src="/images/services/aplicacion-movil/recordatorio-garantia.webp"
          alt="Recordatorio de Garantía"
        />
        <h2 class="text-2xl xl:text-4xl font-medium fs-condensed">
          Registra la Garantía de tu Batería
        </h2>
        <p class="text-sm xl:text-2xl fs-condensed">
          Recibe recodatorios de mantenimiento <br />
          periódico y lleva registro de los mismos <br />
          para no perder la Garantía de tu Batería.
        </p>
      </article>
      <article class="flex flex-col gap-2">
        <img
          src="/images/services/aplicacion-movil/administra-recompensas.webp"
          alt="Administra tus Recompensas"
        />
        <h2 class="text-2xl xl:text-4xl font-medium fs-condensed">
          Administra tus Recompensas
        </h2>
        <p class="text-sm xl:text-2xl fs-condensed">
          Lleva el control de cuantos puntos <br />
          tienes y selecciona que <br />
          puedes obtener con ellos
        </p>
      </article>
    </section>
  `,
})
export class FeaturesAppMovil {}
